var map = {
	"./Index/locales/Index_fr_CA.js": 249,
	"./actions/locales/BasketActions_fr_CA.js": 250,
	"./actions/locales/UserActions_fr_CA.js": 251,
	"./analytics/locales/utils_fr_CA.js": 252,
	"./components/AddReview/AboutMe/locales/AboutMe_fr_CA.js": 253,
	"./components/AddReview/AddReviewNote/locales/AddReviewNote_fr_CA.js": 254,
	"./components/AddReview/AddReview_fr_CA.js": 255,
	"./components/AddReview/PostingConfirmation/locales/PostingConfirmation_fr_CA.js": 256,
	"./components/AddReview/RateAndReview/locales/RateAndReview_fr_CA.js": 257,
	"./components/AddReview/SelectShade/locales/SelectShade_fr_CA.js": 258,
	"./components/AddReview/UploadMedia/locales/UploadMedia_fr_CA.js": 259,
	"./components/AddToBasketButton/locales/AddToBasketButton_fr_CA.js": 260,
	"./components/Addresses/AddressForm/locales/AddressForm_fr_CA.js": 261,
	"./components/Addresses/locales/Address_fr_CA.js": 262,
	"./components/ApplePayButton/locales/ApplePayButton_fr_CA.js": 263,
	"./components/BackToTopButton/locales/BackToTopButton_fr_CA.js": 264,
	"./components/Banner/AcceptCookieBanner/locales/AcceptCookieBanner_fr_CA.js": 265,
	"./components/Banner/AndroidAppBanner/locales/AndroidAppBanner_fr_CA.js": 266,
	"./components/Basket/ActionButtons/locales/ActionButtons_fr_CA.js": 267,
	"./components/Basket/Basket/locales/Basket_fr_CA.js": 268,
	"./components/Basket/BasketList/locales/BasketList_fr_CA.js": 269,
	"./components/Basket/BasketLoves/locales/BasketLoves_fr_CA.js": 270,
	"./components/Basket/BasketMain/locales/BasketMain_fr_CA.js": 271,
	"./components/Basket/BasketOrderSummary/locales/BasketOrderSummary_fr_CA.js": 272,
	"./components/Basket/BasketTitle/locales/BasketTitle_fr_CA.js": 273,
	"./components/Basket/InternationalShipping/locales/InternationalShipping_fr_CA.js": 274,
	"./components/Basket/MobileSamplesList/locales/MobileSamplesList_fr_CA.js": 275,
	"./components/Basket/NeedAssistance/locales/NeedAssistance_fr_CA.js": 276,
	"./components/Basket/PaymentModal/locale/PaymentModal_fr_CA.js": 277,
	"./components/Basket/PickupInsteadModal/locale/PickupInsteadModal_fr_CA.js": 278,
	"./components/Basket/PreBasket/locale/PreBasket_fr_CA.js": 279,
	"./components/Basket/PromoSection/locales/PromoSection_fr_CA.js": 280,
	"./components/Basket/Rewards/MobileRewardsInBasket/locales/MobileRewardsInBasket_fr_CA.js": 281,
	"./components/Basket/Rewards/RewardsCallToAction/locales/RewardsCallToAction_fr_CA.js": 282,
	"./components/Basket/Rewards/locales/Rewards_fr_CA.js": 283,
	"./components/Basket/RopisBasket/RopisBasketOrderSummary/locales/RopisBasketOrderSummary_fr_CA.js": 284,
	"./components/Basket/RopisBasket/locales/RopisBasket_fr_CA.js": 285,
	"./components/Basket/SampleRewardTabs/locales/SampleRewardTabs_fr_CA.js": 286,
	"./components/Basket/ShippingMessage/locales/ShippingMessage_fr_CA.js": 287,
	"./components/Basket/SwitchBasket/locales/SwitchBasket_fr_CA.js": 288,
	"./components/Basket/TaxModal/locale/TaxModal_fr_CA.js": 289,
	"./components/Bcc/BccCarousel/locales/BccCarousel_fr_CA.js": 290,
	"./components/Bcc/BccEmailSmsOptIn/locales/BccEmailSmsOptIn_fr_CA.js": 291,
	"./components/Bcc/BccPlaceHolderApp/locales/BccPlaceHolderApp_fr_CA.js": 292,
	"./components/Bcc/BccProductFinder/locales/BccProductFinder_fr_CA.js": 293,
	"./components/Bcc/BccPromotion/locales/BccPromotion_fr_CA.js": 294,
	"./components/Bcc/BccVideo/locales/BccVideo_fr_CA.js": 295,
	"./components/BeautyBoard/BeautyBoardGalleryNavigation/locales/BeautyBoardGalleryNavigation_fr_CA.js": 296,
	"./components/BeautyBoard/BeautyBoardPrivateProfile/locales/BeautyBoardPrivateProfile_fr_CA.js": 297,
	"./components/BeautyBoard/BeautyBoardPublicProfile/locales/BeautyBoardPublicProfile_fr_CA.js": 298,
	"./components/BeautyBoard/CommunitySubnav/locales/CommunitySubnav_fr_CA.js": 299,
	"./components/BeautyBoard/LookCard/locales/LookCard_fr_CA.js": 300,
	"./components/BeautyMatchBadge/locales/BeautyMatchBadge_fr_CA.js": 301,
	"./components/BeautyWinPromo/locales/BeautyWinPromoBody_fr_CA.js": 302,
	"./components/BiQualify/locales/BiQualify_fr_CA.js": 303,
	"./components/BiRegisterForm/BiBirthdayForm/locales/BiBirthdayForm_fr_CA.js": 304,
	"./components/BiRegisterForm/locales/BiRegisterForm_fr_CA.js": 305,
	"./components/Calendar/CalendarHeader/locales/CalendarHeader_fr_CA.js": 306,
	"./components/Campaigns/Referrer/locales/Referrer_fr_CA.js": 307,
	"./components/Carousel/locales/Carousel_fr_CA.js": 308,
	"./components/CategoryTree/locales/CategoryTree_fr_CA.js": 309,
	"./components/Checkout/AccordionSection/locales/AccordionSection_fr_CA.js": 310,
	"./components/Checkout/OrderSummary/CheckoutPromoSection/locales/CheckoutPromoSection_fr_CA.js": 311,
	"./components/Checkout/OrderSummary/OrderTotalSection/locales/OrderTotalSection_fr_CA.js": 312,
	"./components/Checkout/OrderSummary/locales/OrderSummary_fr_CA.js": 313,
	"./components/Checkout/PlaceOrderButton/locales/PlaceOrderButton_fr_CA.js": 314,
	"./components/Checkout/RopisCheckout/locales/RopisCheckout_fr_CA.js": 315,
	"./components/Checkout/Sections/AccountCreation/locales/AccountCreation_fr_CA.js": 316,
	"./components/Checkout/Sections/GiftCardShipOptions/locales/GiftCardShipOptionsForm_fr_CA.js": 317,
	"./components/Checkout/Sections/Payment/CheckoutCreditCardForm/locales/CheckoutCreditCardForm_fr_CA.js": 318,
	"./components/Checkout/Sections/Payment/Display/locales/PaymentDisplay_fr_CA.js": 319,
	"./components/Checkout/Sections/Payment/GiftCardSection/locales/GiftCardSection_fr_CA.js": 320,
	"./components/Checkout/Sections/Payment/Section/locales/PaymentSection_fr_CA.js": 321,
	"./components/Checkout/Sections/PickUpOrderContactInfo/locales/PickUpOrderContactInfo_fr_CA.js": 322,
	"./components/Checkout/Sections/PickUpOrderLocation/locales/PickUpOrderLocation_fr_CA.js": 323,
	"./components/Checkout/Sections/Review/locales/ReviewText_fr_CA.js": 324,
	"./components/Checkout/Sections/ShipAddress/locales/ShipAddress_fr_CA.js": 325,
	"./components/Checkout/Sections/ShipOptions/locales/ShipOptions_fr_CA.js": 326,
	"./components/Checkout/Shared/Flash/FlashTermsConditions/locales/FlashTermsConditions_fr_CA.js": 327,
	"./components/Checkout/Shared/Guest/locales/GuestSavePointsCheckbox_fr_CA.js": 328,
	"./components/Checkout/Shared/PayPal/locales/SaveToAccountCheckbox_fr_CA.js": 329,
	"./components/Checkout/Shared/ShippingCalculationInfoMessage/locales/ShippingCalculationInfoMessage_fr_CA.js": 330,
	"./components/Checkout/Shared/locales/UpdateError_fr_CA.js": 331,
	"./components/Checkout/locales/CheckoutMain_fr_CA.js": 332,
	"./components/CheckoutButton/locales/CheckoutButton_fr_CA.js": 333,
	"./components/CommunitySubnav/locales/CommunitySubnav_fr_CA.js": 334,
	"./components/ContentPage/DropdownMW/locales/DropdownMW_fr_CA.js": 335,
	"./components/CountrySwitcher/locales/CountrySwitcher_fr_CA.js": 336,
	"./components/CreditCard/ApplyFlow/ApplyCreditCardLoves/locales/ApplyCreditCardLoves_fr_CA.js": 337,
	"./components/CreditCard/ApplyFlow/ApplyFlowResponse/locales/ApplyFlowResponse_fr_CA.js": 338,
	"./components/CreditCard/ApplyFlow/ContentInformationRules/locales/ContentInformationRules_fr_CA.js": 339,
	"./components/CreditCard/ApplyFlow/ElectronicConsent/locales/ElectronicConsent_fr_CA.js": 340,
	"./components/CreditCard/ApplyFlow/OpeningAccount/locales/OpeningAccount_fr_CA.js": 341,
	"./components/CreditCard/ApplyFlow/PersonalInformation/locales/PersonalInformation_fr_CA.js": 342,
	"./components/CreditCard/ApplyFlow/SecureInformation/locales/SecureInformation_fr_CA.js": 343,
	"./components/CreditCard/ApplyFlow/locales/ApplyFlowMain_fr_CA.js": 344,
	"./components/CreditCard/MarketingPage/locales/MarketingPage_fr_CA.js": 345,
	"./components/CreditCard/Rewards/ScanRewards/locales/BiCardRewards_fr_CA.js": 346,
	"./components/CreditCard/Rewards/ScanRewards/locales/CreditCardRewards_fr_CA.js": 347,
	"./components/CreditCard/Rewards/ScanRewards/locales/ScanRewardButton_fr_CA.js": 348,
	"./components/CreditCard/Rewards/locales/RewardList_fr_CA.js": 349,
	"./components/CreditCard/Rewards/locales/Reward_fr_CA.js": 350,
	"./components/CurbsidePickupIndicator/locales/CurbsidePickupIndicator_fr_CA.js": 351,
	"./components/CustomerServiceChat/locales/CustomerServiceChat_fr_CA.js": 352,
	"./components/EmailSignUp/locales/EmailSignUp_fr_CA.js": 353,
	"./components/EmailUs/locales/EmailUs_fr_CA.js": 354,
	"./components/EmailUs/locales/constants_fr_CA.js": 355,
	"./components/ErrorPages/locales/Error404_fr_CA.js": 356,
	"./components/Footer/locales/Footer_fr_CA.js": 357,
	"./components/GiftCards/locales/GiftCards_fr_CA.js": 358,
	"./components/GlobalModals/AddToBasketModal/locales/AddToBasketModal_fr_CA.js": 359,
	"./components/GlobalModals/BiRegisterModal/locales/BiRegisterModal_fr_CA.js": 360,
	"./components/GlobalModals/BookWidgetModal/locales/BookWidgetModal_fr_CA.js": 361,
	"./components/GlobalModals/CancelReservationModal/locales/CancelReservationModal_fr_CA.js": 362,
	"./components/GlobalModals/ColorIQModal/locales/ColorIQModal_fr_CA.js": 363,
	"./components/GlobalModals/CountrySwitcherModal/locales/CountrySwitcherModal_fr_CA.js": 364,
	"./components/GlobalModals/CreditReportDetailsModal/locales/CreditReportDetailsModal_fr_CA.js": 365,
	"./components/GlobalModals/EDP/GoogleMapModal/locales/GoogleMapModal_fr_CA.js": 366,
	"./components/GlobalModals/EDP/SignInWithAuthenticateModal/GuestForm/locales/GuestForm_fr_CA.js": 367,
	"./components/GlobalModals/EDP/SignInWithAuthenticateModal/PhoneNumberModal/locales/PhoneNumberModal_fr_CA.js": 368,
	"./components/GlobalModals/EDP/SignInWithAuthenticateModal/locales/SignInWithAuthenticateModal_fr_CA.js": 369,
	"./components/GlobalModals/EmailMeWhenInStockModal/locales/EmailMeWhenInStockModal_fr_CA.js": 370,
	"./components/GlobalModals/FindInStore/FindInStoreAddress/locales/FindInStoreAddress_fr_CA.js": 371,
	"./components/GlobalModals/FindInStore/FindInStoreMapModal/locales/FindInStoreMapModal_fr_CA.js": 372,
	"./components/GlobalModals/FindInStore/FindInStoreModal/locales/FindInStoreModal_fr_CA.js": 373,
	"./components/GlobalModals/ForgotPasswordModal/locales/ForgotPasswordModal_fr_CA.js": 374,
	"./components/GlobalModals/KlarnaModal/locales/KlarnaModal_fr_CA.js": 375,
	"./components/GlobalModals/OrderCancelationModal/locales/OrderCancelationModal_fr_CA.js": 376,
	"./components/GlobalModals/PaidReservationModal/PaymentSection/PaymentSectionContent/PaymentInfo/BillingAddressForm/locales/BillingAddressForm_fr_CA.js": 377,
	"./components/GlobalModals/PaidReservationModal/PaymentSection/PaymentSectionContent/PaymentInfo/CreditCardForm/locales/CreditCardForm_fr_CA.js": 378,
	"./components/GlobalModals/PaidReservationModal/PaymentSection/PaymentSectionContent/PaymentInfo/locales/PaymentInfo_fr_CA.js": 379,
	"./components/GlobalModals/PaidReservationModal/UserInfoSection/locales/UserInfoSection_fr_CA.js": 380,
	"./components/GlobalModals/PaidReservationModal/WaiverSection/locales/WaiverSection_fr_CA.js": 381,
	"./components/GlobalModals/PaidReservationModal/locales/PaidReservationModal_fr_CA.js": 382,
	"./components/GlobalModals/QuickLookModal/ProductQuickLookModal/CallToActions/locales/CallToActions_fr_CA.js": 383,
	"./components/GlobalModals/QuickLookModal/ProductQuickLookModal/CallToActions/locales/FlashButtons_fr_CA.js": 384,
	"./components/GlobalModals/QuickLookModal/ProductQuickLookModal/CallToActions/locales/Reward_fr_CA.js": 385,
	"./components/GlobalModals/QuickLookModal/ProductQuickLookModal/ProductQuickLookMessage/locales/ProductQuickLookMessage_fr_CA.js": 386,
	"./components/GlobalModals/QuickLookModal/ProductQuickLookModal/locales/ProductQuickLookModal_fr_CA.js": 387,
	"./components/GlobalModals/QuickLookModal/RewardSampleQuickLookModal/locales/RewardSampleQuickLookModal_fr_CA.js": 388,
	"./components/GlobalModals/RegisterModal/RegisterForm/locales/RegisterForm_fr_CA.js": 389,
	"./components/GlobalModals/RegisterModal/locales/RegisterModal_fr_CA.js": 390,
	"./components/GlobalModals/ReserveAndPickUpModal/locales/ReserveAndPickUpModal_fr_CA.js": 391,
	"./components/GlobalModals/ReserveAndPickUpModal/locales/StoresList_fr_CA.js": 392,
	"./components/GlobalModals/RewardModal/locales/RewardModal_fr_CA.js": 393,
	"./components/GlobalModals/RougeRewardCardModal/locales/RougeRewardCardButtons_fr_CA.js": 394,
	"./components/GlobalModals/RougeRewardCardModal/locales/RougeRewardCardModal_fr_CA.js": 395,
	"./components/GlobalModals/SampleModal/locales/SampleModal_fr_CA.js": 396,
	"./components/GlobalModals/ScanRewardCardModal/locales/ScanRewardCardModal_fr_CA.js": 397,
	"./components/GlobalModals/ShareLinkModal/locales/ShareLinkModal_fr_CA.js": 398,
	"./components/GlobalModals/SignInModal/SignInForm/locales/SignInForm_fr_CA.js": 399,
	"./components/GlobalModals/SignInModal/SignInFormFooter/locales/SignInFormFooter_fr_CA.js": 400,
	"./components/GlobalModals/SignInModal/locales/SignInModal_fr_CA.js": 401,
	"./components/GlobalModals/SignInWithMessagingModal/CreditCardApplyMessaging/locales/CreditCardApplyMessaging_fr_CA.js": 402,
	"./components/GlobalModals/SignInWithMessagingModal/GuestCheckoutMessaging/locales/GuestCheckoutMessaging_fr_CA.js": 403,
	"./components/GlobalModals/SignInWithMessagingModal/locales/SignInWithMessagingModal_fr_CA.js": 404,
	"./components/GlobalModals/SimilarProductsModal/locales/SimilarProductsModal_fr_CA.js": 405,
	"./components/GlobalModals/SocialReOptModal/locales/SocialReOptModal_fr_CA.js": 406,
	"./components/GlobalModals/SocialRegistrationModal/locales/SocialRegistrationModal_fr_CA.js": 407,
	"./components/GlobalModals/locales/modals_fr_CA.js": 408,
	"./components/GoogleMap/InfoWindow/locales/InfoWindow_fr_CA.js": 409,
	"./components/Header/AccountGreeting/locales/AccountGreeting_fr_CA.js": 410,
	"./components/Header/AccountMenu/locales/AccountMenu_fr_CA.js": 411,
	"./components/Header/CommunityContent/locales/CommunityContent_fr_CA.js": 412,
	"./components/Header/InlineLoves/locales/InlineLoves_fr_CA.js": 413,
	"./components/Header/PersistentBanner/locales/PersistentBanner_fr_CA.js": 414,
	"./components/Header/ShopModal/locales/ShopModal_fr_CA.js": 415,
	"./components/Header/StoresContent/locales/StoresContent_fr_CA.js": 416,
	"./components/Header/locales/Header_fr_CA.js": 417,
	"./components/HomePage/BIRewardsCarousel/locales/BIRewardsCarousel_fr_CA.js": 418,
	"./components/HomePage/RecentlyViewed/locales/RecentlyViewed_fr_CA.js": 419,
	"./components/InlineBasket/BasketDesktop/locales/BasketDesktop_fr_CA.js": 420,
	"./components/InlineBasket/BasketDesktop/locales/BasketItem_fr_CA.js": 421,
	"./components/InlineBasket/BasketMobile/locales/BasketMobile_fr_CA.js": 422,
	"./components/InlineBasket/BasketMsg/locales/BasketMsg_fr_CA.js": 423,
	"./components/InlineBasket/locales/InlineBasket_fr_CA.js": 424,
	"./components/Inputs/InputZip/locales/InputZip_fr_CA.js": 425,
	"./components/Inputs/Textarea/locales/Textarea_fr_CA.js": 426,
	"./components/Klarna/KlarnaPaymentMethod/locales/KlarnaPaymentMethod_fr_CA.js": 427,
	"./components/Klarna/locales/Klarna_fr_CA.js": 428,
	"./components/LegacyCarousel/locales/LegacyCarousel_fr_CA.js": 429,
	"./components/LegacyCatalog/CatalogPage/locales/CatalogPage_fr_CA.js": 430,
	"./components/LegacyCatalog/Navigation/NavigationFS/locales/NavigationFS_fr_CA.js": 431,
	"./components/LegacyCatalog/Navigation/NavigationMW/locales/NavigationMW_fr_CA.js": 432,
	"./components/LegacyCatalog/NoResults/locales/NoResults_fr_CA.js": 433,
	"./components/LegacyCatalog/NoSearchResults/locales/NoSearchResults_fr_CA.js": 434,
	"./components/LegacyCatalog/PageSizeSelect/locales/PageSizeSelect_fr_CA.js": 435,
	"./components/LegacyCatalog/ProductSort/locales/ProductSort_fr_CA.js": 436,
	"./components/LegacyCatalog/ProductSort/locales/settings_fr_CA.js": 437,
	"./components/LegacyCatalog/RefinementBox/locales/RefinementBox_fr_CA.js": 438,
	"./components/LegacyCatalog/locales/ProductRefinements_fr_CA.js": 439,
	"./components/Modal/locales/Modal_fr_CA.js": 440,
	"./components/OnlineReservation/ExperienceDetailPage/ActionsNav/locales/ActionsNav_fr_CA.js": 441,
	"./components/OnlineReservation/ExperienceDetailPage/BookWidget/locales/BookWidget_fr_CA.js": 442,
	"./components/OnlineReservation/ExperienceDetailPage/DatePickerWidget/locales/DatePickerWidget_fr_CA.js": 443,
	"./components/OnlineReservation/ExperienceDetailPage/ExperienceLocation/locales/ExperienceLocation_fr_CA.js": 444,
	"./components/OnlineReservation/ExperienceDetailPage/ExperienceSubnav/locales/ExperienceSubnav_fr_CA.js": 445,
	"./components/OnlineReservation/ExperienceDetailPage/RsvpWidget/locales/RsvpWidget_fr_CA.js": 446,
	"./components/OnlineReservation/ExperienceDetailPage/StoreInformation/locales/StoreInformation_fr_CA.js": 447,
	"./components/OnlineReservation/ExperienceDetailPage/StoresAvailability/StoreTimeSlots/locales/StoreTimeSlots_fr_CA.js": 448,
	"./components/OnlineReservation/ExperienceDetailPage/StoresAvailability/locales/StoresAvailability_fr_CA.js": 449,
	"./components/OnlineReservation/ExperienceDetailPage/locales/Confirmation_fr_CA.js": 450,
	"./components/OnlineReservation/ExperienceDetailPage/locales/ExperienceInfo_fr_CA.js": 451,
	"./components/OnlineReservation/StoreHub/ActivityCard/locales/ActivityCard_fr_CA.js": 452,
	"./components/OnlineReservation/StoreHub/ActivityCarousel/locales/ActivityCarousel_fr_CA.js": 453,
	"./components/OnlineReservation/StoreHub/ActivityFilterBanner/FilterByDay/locales/FilterByDay_fr_CA.js": 454,
	"./components/OnlineReservation/StoreHub/ActivityFilterBanner/FilterByLocation/locales/FilterByLocation_fr_CA.js": 455,
	"./components/OnlineReservation/StoreHub/ActivityFilterBanner/FilterByStore/locales/FilterByStore_fr_CA.js": 456,
	"./components/OnlineReservation/StoreHub/ActivityFilterBanner/locales/ActivityFilterBanner_fr_CA.js": 457,
	"./components/OnlineReservation/StoreHub/ActivityGridView/locales/ActivityGridView_fr_CA.js": 458,
	"./components/OnlineReservation/StoreHub/locales/StoreHubContent_fr_CA.js": 459,
	"./components/OnlineReservation/UpcomingReservations/locales/UpcomingReservations_fr_CA.js": 460,
	"./components/OnlineReservation/locales/ServicesBreadcrumbs_fr_CA.js": 461,
	"./components/OnlineReservation/locales/ServicesFAQ_fr_CA.js": 462,
	"./components/OnlineReservation/locales/activityConstants_fr_CA.js": 463,
	"./components/OnlyFewLeftFlag/locales/OnlyFewLeftFlag_fr_CA.js": 464,
	"./components/OrderConfirmation/BeautyInsiderSection/MyBeautyBank/locales/MyBeautyBank_fr_CA.js": 465,
	"./components/OrderConfirmation/BeautyInsiderSection/locales/BeautyInsiderSection_fr_CA.js": 466,
	"./components/OrderConfirmation/GuestCheckoutSection/locales/GuestCheckoutSection_fr_CA.js": 467,
	"./components/OrderConfirmation/OrderItemList/OrderItem/locales/OrderItem_fr_CA.js": 468,
	"./components/OrderConfirmation/OrderItemList/locales/OrderItemList_fr_CA.js": 469,
	"./components/OrderConfirmation/OrderTotal/locales/OrderTotal_fr_CA.js": 470,
	"./components/OrderConfirmation/locales/OrderConfirmation_fr_CA.js": 471,
	"./components/PanZoom/locales/PanZoom_fr_CA.js": 472,
	"./components/PayPalButton/locales/PayPalButton_fr_CA.js": 473,
	"./components/PlayQuiz/PageTemplates/Question/locales/Question_fr_CA.js": 474,
	"./components/PlayQuiz/PlayQuizNotification/locales/PlayQuizNotification_fr_CA.js": 475,
	"./components/PlayQuiz/locales/PlayQuiz_fr_CA.js": 476,
	"./components/Preview/locale/Preview_fr_CA.js": 477,
	"./components/Product/Price/locales/Price_fr_CA.js": 478,
	"./components/Product/ProductBadges/locales/ProductBadges_fr_CA.js": 479,
	"./components/Product/ProductCard/locales/ProductCard_fr_CA.js": 480,
	"./components/Product/ProductItem/locales/ProductItem_fr_CA.js": 481,
	"./components/Product/ProductListItem/locales/ProductListItem_fr_CA.js": 482,
	"./components/Product/ProductLove/ProductLoveButton/locales/ProductLoveButton_fr_CA.js": 483,
	"./components/Product/ProductLove/ProductLoveToggle/locales/ProductLoveToggle_fr_CA.js": 484,
	"./components/Product/ProductLovesCount/locales/ProductLovesCount_fr_CA.js": 485,
	"./components/Product/ProductQuicklook/locales/ProductQuicklook_fr_CA.js": 486,
	"./components/Product/ProductSort/locales/ProductSortOptions_fr_CA.js": 487,
	"./components/Product/ProductSort/locales/ProductSort_fr_CA.js": 488,
	"./components/Product/ProductTile/locales/ProductTile_fr_CA.js": 489,
	"./components/Product/ProductVariation/locales/ProductVariation_fr_CA.js": 490,
	"./components/Product/PromoItem/locales/PromoItem_fr_CA.js": 491,
	"./components/Product/ReviewCount/locales/ReviewCount_fr_CA.js": 492,
	"./components/Product/SampleItem/locales/SampleItem_fr_CA.js": 493,
	"./components/Product/SizeAndItemNumber/locales/SizeAndItemNumber_fr_CA.js": 494,
	"./components/Product/SkuQuantity/locales/SkuQuantity_fr_CA.js": 495,
	"./components/Product/ViewSimilarProductsCTA/locales/ViewSimilarProductsCTA_fr_CA.js": 496,
	"./components/ProductPage/AddStructure/locales/AddStructure_fr_CA.js": 497,
	"./components/ProductPage/BeautyMatchTooltip/locales/BeautyMatchTooltip_fr_CA.js": 498,
	"./components/ProductPage/CallToAction/locales/CallToAction_fr_CA.js": 499,
	"./components/ProductPage/ColorIQBadge/locales/ColorIQBadge_fr_CA.js": 500,
	"./components/ProductPage/Feedback/locales/Feedback_fr_CA.js": 501,
	"./components/ProductPage/Filters/Filter/locales/Filter_fr_CA.js": 502,
	"./components/ProductPage/Filters/FilterGroup/locales/FilterGroup_fr_CA.js": 503,
	"./components/ProductPage/GalleryCardCarousel/GalleryCard/locales/GalleryCard_fr_CA.js": 504,
	"./components/ProductPage/GalleryCardCarousel/SeeMoreCard/locales/SeeMoreCard_fr_CA.js": 505,
	"./components/ProductPage/GalleryCardCarousel/locales/GalleryCardCarousel_fr_CA.js": 506,
	"./components/ProductPage/LovesCount/locales/LovesCount_fr_CA.js": 507,
	"./components/ProductPage/ProductMediaCarousel/ThumbnailCarousel/locales/ThumbnailCarousel_fr_CA.js": 508,
	"./components/ProductPage/QuestionsAndAnswers/locales/QuestionsAndAnswers_fr_CA.js": 509,
	"./components/ProductPage/RatingsAndReviews/Review/locales/Review_fr_CA.js": 510,
	"./components/ProductPage/RatingsAndReviews/ReviewImageModal/locales/ReviewImageModal_fr_CA.js": 511,
	"./components/ProductPage/RatingsAndReviews/ReviewsFilters/locales/ReviewsFilters_fr_CA.js": 512,
	"./components/ProductPage/RatingsAndReviews/ReviewsStats/locales/ReviewsStats_fr_CA.js": 513,
	"./components/ProductPage/RatingsAndReviews/Sentiments/locales/Sentiments_fr_CA.js": 514,
	"./components/ProductPage/RatingsAndReviews/locales/RatingsAndReviews_fr_CA.js": 515,
	"./components/ProductPage/ReviewsAnchor/locales/ReviewsAnchor_fr_CA.js": 516,
	"./components/ProductPage/ReviewsImageCarousel/locales/ReviewsImageCarousel_fr_CA.js": 517,
	"./components/ProductPage/Ropis/locales/ReserveOnlinePickUpInStore_fr_CA.js": 518,
	"./components/ProductPage/ShadeFilter/locales/ShadeFilter_fr_CA.js": 519,
	"./components/ProductPage/ShadeFinderText/locales/ShadeFinderText_fr_CA.js": 520,
	"./components/ProductPage/Swatches/locales/Swatches_fr_CA.js": 521,
	"./components/ProductPage/Type/DigitalProduct/FlashButtons/locales/FlashButtons_fr_CA.js": 522,
	"./components/ProductPage/Type/RewardProduct/RougeRewardButton/locales/RougeRewardButton_fr_CA.js": 523,
	"./components/ProductPage/Wizard/locales/Wizard_fr_CA.js": 524,
	"./components/ProductPage/locales/RwdProductPage_fr_CA.js": 525,
	"./components/ReCaptchaText/locales/ReCaptchaText_fr_CA.js": 526,
	"./components/RelatedLinks/locales/RelatedLinks_fr_CA.js": 527,
	"./components/ResetPassword/locales/ResetPassword_fr_CA.js": 528,
	"./components/Reward/BiUnavailable/locales/BiUnavailable_fr_CA.js": 529,
	"./components/Reward/LoyaltyPromo/locales/LoyaltyPromo_fr_CA.js": 530,
	"./components/Reward/RewardItem/locales/RewardItem_fr_CA.js": 531,
	"./components/RewardsBazaar/locales/RewardsBazaar_fr_CA.js": 532,
	"./components/RichProfile/BeautyInsider/BeautyInsiderCash/locales/BeautyInsiderCash_fr_CA.js": 533,
	"./components/RichProfile/BeautyInsider/BeautyInsiderPointMultiplier/locales/BeautyInsiderPointMultiplier_fr_CA.js": 534,
	"./components/RichProfile/BeautyInsider/BiInfoCard/locales/BiInfoCard_fr_CA.js": 535,
	"./components/RichProfile/BeautyInsider/BiWelcomeCard/locales/BiWelcomeCard_fr_CA.js": 536,
	"./components/RichProfile/BeautyInsider/CreditCardRewards/locales/CreditCardRewards_fr_CA.js": 537,
	"./components/RichProfile/BeautyInsider/PointsForDiscount/locales/PointsForDiscount_fr_CA.js": 538,
	"./components/RichProfile/BeautyInsider/PointsNSpendBank/AllBankActivity/locales/AllBankActivity_fr_CA.js": 539,
	"./components/RichProfile/BeautyInsider/PointsNSpendBank/PointsNSpendGrid/locales/PointsNSpendGrid_fr_CA.js": 540,
	"./components/RichProfile/BeautyInsider/PointsNSpendBank/RecentBankActivity/locales/RecentBankActivity_fr_CA.js": 541,
	"./components/RichProfile/BeautyInsider/PointsNSpendBank/locales/BIPointsDisclaimer_fr_CA.js": 542,
	"./components/RichProfile/BeautyInsider/PointsNSpendBank/locales/BIPointsWarnings_fr_CA.js": 543,
	"./components/RichProfile/BeautyInsider/RecentPointsActivity/locales/RecentPointsActivity_fr_CA.js": 544,
	"./components/RichProfile/BeautyInsider/RecentRewardActivity/locales/RecentRewardActivity_fr_CA.js": 545,
	"./components/RichProfile/BeautyInsider/ReferFriends/locales/ReferFriends_fr_CA.js": 546,
	"./components/RichProfile/BeautyInsider/RewardsCarousel/locales/RewardsCarousel_fr_CA.js": 547,
	"./components/RichProfile/BeautyInsider/SignInSignUp/locales/SignInSignUp_fr_CA.js": 548,
	"./components/RichProfile/BeautyInsider/ValueChips/locales/ValueChips_fr_CA.js": 549,
	"./components/RichProfile/BeautyInsider/ValueTable/locales/ValueTable_fr_CA.js": 550,
	"./components/RichProfile/BeautyInsider/locales/BeautyInsider_fr_CA.js": 551,
	"./components/RichProfile/CommunityError/locales/CommunityError_fr_CA.js": 552,
	"./components/RichProfile/CreditCards/locales/CreditCards_fr_CA.js": 553,
	"./components/RichProfile/EditMyProfile/Content/BioProfile/locales/BioProfile_fr_CA.js": 554,
	"./components/RichProfile/EditMyProfile/Content/Birthday/locales/Birthday_fr_CA.js": 555,
	"./components/RichProfile/EditMyProfile/Content/ColorIQ/locales/ColorIQ_fr_CA.js": 556,
	"./components/RichProfile/EditMyProfile/Content/Eyes/locales/Eyes_fr_CA.js": 557,
	"./components/RichProfile/EditMyProfile/Content/Hair/locales/Hair_fr_CA.js": 558,
	"./components/RichProfile/EditMyProfile/Content/Privacy/locales/Privacy_fr_CA.js": 559,
	"./components/RichProfile/EditMyProfile/Content/Skin/locales/Skin_fr_CA.js": 560,
	"./components/RichProfile/EditMyProfile/Content/locales/ContentHeading_fr_CA.js": 561,
	"./components/RichProfile/EditMyProfile/EditMyProfileFS/locales/EditMyProfileFS_fr_CA.js": 562,
	"./components/RichProfile/EditMyProfile/Modals/EditMyProfileModal/locales/EditMyProfileModal_fr_CA.js": 563,
	"./components/RichProfile/ListPageHeader/locales/ListPageHeader_fr_CA.js": 564,
	"./components/RichProfile/Lists/ListsLoves/locales/ListsLoves_fr_CA.js": 565,
	"./components/RichProfile/Lists/ListsStoreServices/locales/ListsStoreServices_fr_CA.js": 566,
	"./components/RichProfile/Lists/locales/ListsHeader_fr_CA.js": 567,
	"./components/RichProfile/Lists/locales/Lists_fr_CA.js": 568,
	"./components/RichProfile/MyAccount/AccountInfo/AccountBirthday/locales/AccountBirthday_fr_CA.js": 569,
	"./components/RichProfile/MyAccount/AccountInfo/AccountEmail/locales/AccountEmail_fr_CA.js": 570,
	"./components/RichProfile/MyAccount/AccountInfo/AccountName/locales/AccountName_fr_CA.js": 571,
	"./components/RichProfile/MyAccount/AccountInfo/AccountPassword/locales/AccountPassword_fr_CA.js": 572,
	"./components/RichProfile/MyAccount/AccountInfo/locales/AccountInfo_fr_CA.js": 573,
	"./components/RichProfile/MyAccount/AccountLayout/locales/AccountNav_fr_CA.js": 574,
	"./components/RichProfile/MyAccount/Addresses/AcctAddressForm/locales/AcctAddressForm_fr_CA.js": 575,
	"./components/RichProfile/MyAccount/Addresses/locales/Addresses_fr_CA.js": 576,
	"./components/RichProfile/MyAccount/MailingPrefs/NotificationsAndRemindersPrefs/locales/NotificationsAndRemindersPrefs_fr_CA.js": 577,
	"./components/RichProfile/MyAccount/MailingPrefs/PostalMailPrefs/locales/PostalMailPrefs_fr_CA.js": 578,
	"./components/RichProfile/MyAccount/MailingPrefs/PromotionalEmailsPrefs/locales/PromotionalEmailsPrefs_fr_CA.js": 579,
	"./components/RichProfile/MyAccount/MailingPrefs/locales/MailingPrefs_fr_CA.js": 580,
	"./components/RichProfile/MyAccount/OrderDetail/PickupOrderStatus/locales/PickupOrderStatus_fr_CA.js": 581,
	"./components/RichProfile/MyAccount/OrderDetail/locales/OrderDetail_fr_CA.js": 582,
	"./components/RichProfile/MyAccount/OrderDetail/locales/OrderShippingGroups_fr_CA.js": 583,
	"./components/RichProfile/MyAccount/OrderStatusLookup/locales/OrderStatusLookup_fr_CA.js": 584,
	"./components/RichProfile/MyAccount/Payments/CreditCards/CreditCardForm/locales/CreditCardForm_fr_CA.js": 585,
	"./components/RichProfile/MyAccount/Payments/CreditCards/locales/CreditCards_fr_CA.js": 586,
	"./components/RichProfile/MyAccount/Payments/OtherPayments/locales/OtherPayments_fr_CA.js": 587,
	"./components/RichProfile/MyAccount/Payments/locales/Payments_fr_CA.js": 588,
	"./components/RichProfile/MyAccount/RecentOrders/locales/RecentOrders_fr_CA.js": 589,
	"./components/RichProfile/MyAccount/ReturnLink/locales/ReturnLink_fr_CA.js": 590,
	"./components/RichProfile/MyAccount/Subscriptions/Flash/locales/Flash_fr_CA.js": 591,
	"./components/RichProfile/MyAccount/Subscriptions/locales/Subscriptions_fr_CA.js": 592,
	"./components/RichProfile/MyAccount/TrackOrderButton/locales/TrackOrderButton_fr_CA.js": 593,
	"./components/RichProfile/MyAccount/locales/PleaseSignIn_fr_CA.js": 594,
	"./components/RichProfile/ProfileSubnav/locales/ProfileSubnav_fr_CA.js": 595,
	"./components/RichProfile/PurchaseHistoryList/PurchasedGroups/locales/PurchasedGroups_fr_CA.js": 596,
	"./components/RichProfile/PurchaseHistoryList/PurchasesFilter/locales/PurchasesFilterOptions_fr_CA.js": 597,
	"./components/RichProfile/PurchaseHistoryList/PurchasesFilter/locales/PurchasesFilter_fr_CA.js": 598,
	"./components/RichProfile/PurchaseHistoryList/locales/PurchaseHistoryList_fr_CA.js": 599,
	"./components/RichProfile/StoreServices/EmptyService/locales/EmptyService_fr_CA.js": 600,
	"./components/RichProfile/StoreServices/Service/locales/Service_fr_CA.js": 601,
	"./components/RichProfile/StoreServices/locales/AllStoreServices_fr_CA.js": 602,
	"./components/RichProfile/UserProfile/MyProfile/locales/MyProfile_fr_CA.js": 603,
	"./components/RichProfile/UserProfile/PrivateProfile/locales/PrivateProfile_fr_CA.js": 604,
	"./components/RichProfile/UserProfile/PublicProfile/locales/PublicProfile_fr_CA.js": 605,
	"./components/RichProfile/UserProfile/UserProfile_fr_CA.js": 606,
	"./components/RichProfile/UserProfile/common/AboutMeSlideshow/AboutMeSlide/locales/AboutMeSlide_fr_CA.js": 607,
	"./components/RichProfile/UserProfile/common/AboutMeSlideshow/BiProfileSlide/locales/BiProfileSlide_fr_CA.js": 608,
	"./components/RichProfile/UserProfile/common/AboutMeSlideshow/SocialSlide/locales/SocialSlide_fr_CA.js": 609,
	"./components/RichProfile/UserProfile/common/AboutMeSlideshow/locales/AboutMeSlideshow_fr_CA.js": 610,
	"./components/RichProfile/UserProfile/common/CommunityRibbon/locales/CommunityRibbon_fr_CA.js": 611,
	"./components/RichProfile/UserProfile/common/Conversations/locales/Conversations_fr_CA.js": 612,
	"./components/RichProfile/UserProfile/common/FollowList/locales/FollowList_fr_CA.js": 613,
	"./components/RichProfile/UserProfile/common/Groups/Group/locales/Group_fr_CA.js": 614,
	"./components/RichProfile/UserProfile/common/Groups/locales/Groups_fr_CA.js": 615,
	"./components/RichProfile/UserProfile/common/JoinCommunity/locales/JoinCommunity_fr_CA.js": 616,
	"./components/RichProfile/UserProfile/common/RecentPurchases/locales/RecentPurchases_fr_CA.js": 617,
	"./components/RichProfile/UserProfile/common/RecentReviews/locales/RecentReviews_fr_CA.js": 618,
	"./components/RichProfile/UserProfile/common/SectionContainer/locales/SectionContainer_fr_CA.js": 619,
	"./components/RichProfile/UserProfile/common/locales/Looks_fr_CA.js": 620,
	"./components/RichProfile/UserProfile/locales/PleaseSignInProfile_fr_CA.js": 621,
	"./components/RichProfile/ViewAllLoves/locales/ViewAllLoves_fr_CA.js": 622,
	"./components/SamplesPage/locales/SamplesPage_fr_CA.js": 623,
	"./components/ShadeFinder/BrandsList/locales/BrandsList_fr_CA.js": 624,
	"./components/ShadeFinder/ProductSelection/ProductSelection_fr_CA.js": 625,
	"./components/ShadeFinder/ProductSelection/locales/ProductSelection_fr_CA.js": 626,
	"./components/ShadeFinder/ResultsScreen/locales/ResultScreen_fr_CA.js": 627,
	"./components/ShadeFinder/SkuSelection/locales/SkuSelection_fr_CA.js": 628,
	"./components/ShadeFinder/locales/StartScreen_fr_CA.js": 629,
	"./components/SharedComponents/Stores/NoStores/locales/NoStores_fr_CA.js": 630,
	"./components/SiteSearch/locales/SiteSearch_fr_CA.js": 631,
	"./components/SmartChat/ChatLink/locales/ChatLink_fr_CA.js": 632,
	"./components/Stores/StoreDetails/locales/StoreDetails_fr_CA.js": 633,
	"./components/Stores/StoreDetails/locales/StoreHours_fr_CA.js": 634,
	"./components/Stores/StoreList/locales/StoreList_fr_CA.js": 635,
	"./components/Stores/StoreLocator/locales/StoreLocatorContent_fr_CA.js": 636,
	"./components/SubscribeEmail/locales/SubscribeEmail_fr_CA.js": 637,
	"./components/VendorLoginPage/locales/VendorLoginPage_fr_CA.js": 638,
	"./components/WelcomePopup/MediaPopupMobile/locales/MediaPopupMobile_fr_CA.js": 639,
	"./components/Wizard/locales/Wizard_fr_CA.js": 640,
	"./components/general_fr_CA.js": 121,
	"./constants/locales/Address_fr_CA.js": 641,
	"./constants/locales/Basket_fr_CA.js": 642,
	"./constants/locales/Constants_fr_CA.js": 643,
	"./constants/locales/TermsOfUse_fr_CA.js": 644,
	"./pages/Basket/locales/Basketpage_fr_CA.js": 209,
	"./pages/Brands/locales/BrandNthCategory_fr_CA.js": 210,
	"./pages/Brands/locales/BrandsList_fr_CA.js": 211,
	"./pages/Category/locales/Category_fr_CA.js": 212,
	"./pages/Community/locales/Gallery_fr_CA.js": 213,
	"./pages/Index/locales/Index_fr_CA.js": 214,
	"./pages/Product/locales/ProductPage_fr_CA.js": 215,
	"./pages/Store/locales/StoreDetail_fr_CA.js": 216,
	"./services/api/thirdparty/locales/messages_fr_CA.js": 645,
	"./utils/locales/Basket_fr_CA.js": 646,
	"./utils/locales/Checkout_fr_CA.js": 647,
	"./utils/locales/CreditCard_fr_CA.js": 648,
	"./utils/locales/Date_fr_CA.js": 649,
	"./utils/locales/ErrorConstants_fr_CA.js": 123,
	"./utils/locales/Errors_fr_CA.js": 650,
	"./utils/locales/ExperienceDetails_fr_CA.js": 651,
	"./utils/locales/Filters/Filters_fr_CA.js": 652,
	"./utils/locales/Klarna_fr_CA.js": 653,
	"./utils/locales/LanguageLocale_fr_CA.js": 654,
	"./utils/locales/Location_fr_CA.js": 655,
	"./utils/locales/MarketingFlags_fr_CA.js": 656,
	"./utils/locales/Promos_fr_CA.js": 657,
	"./utils/locales/Search/Search_fr_CA.js": 658,
	"./utils/locales/Sku_fr_CA.js": 659,
	"./utils/locales/Swatch_fr_CA.js": 660,
	"./utils/locales/User/User_fr_CA.js": 661
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 248;